import { DashboardJobsType, IDashboardJob } from '~/domain/DashboardJobs';
import { useUserSelector } from '~/hooks/useUserSelector';
import { trackEvent } from '../../../../../api/analytics';
import history from '../../../../../history';
import { headerScheduledTabTitles } from '../../utils';
import { CustomTable } from '../CustomTable';
import { renderRow } from './renderRow';

export const ScheduledTabLegacy = () => {
  const user = useUserSelector();

  const handleOnClick = (item: IDashboardJob) => {
    trackEvent('Shifts - Scheduled Shifts Tab - Shift Tile Clicked', {
      shiftId: item?.id,
      shiftSpecialty: item?.specialty,
      procedures: item?.procedures,
      breakTime: item?.lunchBreakTime,
      autoConfirm: item?.autoFill,
      softwares: user?.office_info?.softwares,
      assistedHygiene: item?.isAssistedHygiene,
      tpp: item?.amount,
      professionalId: item?.professional?.id,
      dateTimeConfirmed: item?.jobFilledDatetime,
    });

    history.push(`/dashboard/job/${item.id}/details`);
  };

  return (
    <CustomTable
      type={DashboardJobsType.FILLED}
      renderRow={(item) => renderRow({ item, handleOnClick })}
      headerTitles={headerScheduledTabTitles}
      onRowClick={(item) => handleOnClick(item)}
    />
  );
};
